import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import {
  MultiSelectModule,
  MultiSelectAllModule,
} from '@syncfusion/ej2-angular-dropdowns';
import { SharedModule } from '../shared/shared.module';
import { HomepageRoutingModule } from './homepage-routing.module';
import { HomepageComponent } from './homepage/homepage.component';
import { SearchModule } from '../search/search.module';

@NgModule({
  declarations: [HomepageComponent],
  imports: [
    CommonModule,
    SharedModule,
    HomepageRoutingModule,
    AutocompleteLibModule,
    MultiSelectModule,
    MultiSelectAllModule,
    SearchModule,
  ],
})
export class HomepageModule {}
